/** Strips HTML tags and decodes HTML entities, returning plain text. */
export function stripHtml(html: string): string {
  const txt = new DOMParser().parseFromString(html, 'text/html').body.textContent;
  return txt ?? '';
}

/** Returns the character count of the plain text content within an HTML string. */
export function getTextLength(html: string): number {
  return stripHtml(html).length;
}
